import React from "react";
import Header from "./Header";

const PageLayout = ({ children, hideHeader = false, transparent = false }) => {
  return (
    <>
      {!hideHeader && <Header />}
      <main className="pt-10">{children}</main>
    </>
  );
};

export default PageLayout;
